import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStarFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_892_20183",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_892_20183)",
		children: /* @__PURE__ */ _jsx("path", { d: "M6.57505 20.9613L8.00773 14.7922L3.22125 10.6441L9.53658 10.0961L12 4.27881L14.4634 10.0961L20.7788 10.6441L15.9923 14.7922L17.425 20.9613L12 17.6883L6.57505 20.9613Z" })
	})]
});
export default SvgStarFilled;
